var $508544fa08cae44d$exports = {};
$508544fa08cae44d$exports = {
    "Clear search": `Cancella ricerca`
};


export {$508544fa08cae44d$exports as default};
//# sourceMappingURL=it-IT.mjs.map
